<template>
  <div class="page-loader-container" :class="{'plc--visible': loaderVisible}">
    <div class="loader">
      <p class="loader-fallback">
        {{ $t('login_loading') + '...' }}
      </p>
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageLoader',
  computed: {
    ...mapState({
      loaderVisible: state => state.guide.loaderVisible
    })
  },
  watch: {
    loaderVisible (value) {
      if (value === true) {
        this.$el.classList.remove('plc--hiding')
        this.$el.classList.add('plc--showing')
      } else {
        this.$el.classList.add('plc--hiding')
        this.$el.classList.remove('plc--showing')
        this.$el.classList.remove('plc--visible')
        setTimeout(() => {
          this.$el.classList.remove('plc--hiding')
        }, 320)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "uc/_variables";

$green: #46FF46;
$blue: #2D1EFF;
$pink: #FA55FA;
$yellow: #FFEB50;
$white: #eee;

.page-loader-container {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.9);
    z-index: 20;
    animation-duration: 300ms;
    animation-fill-mode: forwards;
}
.plc--showing {
    display: block;
    animation-name: show-page-loader;
}
.plc--visible {
    display: block;
}
.plc--hiding {
    display: block;
    animation-name: hide-page-loader;
}

.loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100px;
    height: 100px;
    margin: auto;
}

.loader-fallback {
    display: none;
    text-align: center;
    line-height: 100px;
    text-transform: uppercase;
    font-size: 16px;
    color: #ffffff;
}
.ie {
    .loader-fallback {
        display: block;
    }
}

.circular {
    animation: rotate 2s linear infinite;
    height: 100%;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
         stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}

@keyframes color {
    100%,
    0% {
        stroke: $pink;
    }
    40% {
        stroke: $blue;
    }
    66% {
        stroke: $green;
    }
    80%,
    90% {
        stroke: $yellow;
    }
}

@keyframes show-page-loader {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes hide-page-loader {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@media screen and (min-width: $breakpoint3) {
    .loader-fallback {
        font-size: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PageLoader.vue